import { render, staticRenderFns } from "./agentApplyDetail.vue?vue&type=template&id=89cddea2&"
import script from "./agentApplyDetail.vue?vue&type=script&lang=js&"
export * from "./agentApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./agentApplyDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports